import { Gallery } from "components/Gallery/MainPages/Gallery";
import GroupsDetails from "components/Pages/GroupsDetails";
import RelatedUnits from "components/Gallery/MainPages/RelatedUnits";
import { MainFooter } from "components/MainFooter/MainFooter";
import Header from "components/Pages/Header";
import HeaderDescription2 from "components/Pages/HeaderDescription2";
import { get, useGet } from "state/jotai";
import { _project } from "state/store.projects";
import { Box } from "@mui/material";
import { F_UNITS } from "api/full_eido_api";
import { useFetch } from "hooks/fetch/useFetch";
import { _bootstrap } from "state/store.bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useBreak } from "hooks/useBreak";
import Scrollbar from "react-scrollbars-custom";
import BackgroundImagePreloader from "main/Preloading/BackgroundFullEidoWebsiteImageLoader";

export const Unitpage = () => {
  const isDesktop = useBreak('md_up')
    
    return (
        <>
          {
            isDesktop ?
              <Scrollbar trackYProps={{
                renderer: (props) => {
                  const { elementRef, ...restProps } = props;
    
                  return <span {...restProps} ref={elementRef}
                         className="trackY" style={{ ...restProps.style }} />;
                },
              }}>
                <RenderComponent />
              </Scrollbar>
              : 
              <RenderComponent />
          }
        </>
      )
};

const RenderComponent = () => {
  const rawUnits = get(_project, "unitsraw", "Units");
  const [relatedUnits, setRelatedUnits] = useState([])
  const { i18n: { language } } = useTranslation();
  const [unitData, setUnitData] = useState({})
  const pid = useGet(_bootstrap).projectids?.[0] || null;
  const UnitpageData = useFetch({ url:F_UNITS(pid, language) }).D

 useEffect(()=> {
    if(Object.keys(UnitpageData || {}).length) {
      setUnitData(UnitpageData)
      const ru = rawUnits.filter((u) => UnitpageData?.UnitSlider?.unitIds?.includes(u.UnitID) && u?.Data?.UnitStatusID?.Value !== 30 && u?.Data?.UnitStatusID?.Value !== 40)
   
      if(ru.length) {
        setRelatedUnits(ru)
      }
    }
  }, [UnitpageData, rawUnits, language])
  
  return (
    <div>
      {/* 🔥 Preload top 5 gallery images invisibly */}
      <BackgroundImagePreloader imageUrls={unitData?.GallerySlider?.ListOfPhotos} limit={5} />
      <Header page="unitpage" {...unitData}/>
      <HeaderDescription2 page="unitpage"  {...unitData}/>
       { Boolean(unitData?.GallerySlider?.ListOfPhotos?.length) && <Gallery {...unitData} page="unitpage"/>} 
      <Box
        sx={{
        px: { xs: 0, sm: 3, md: 3, xl:3 ,lg:3},
 
          maxWidth: "1344px",
          margin: "0 auto",
        }}
            >
        <GroupsDetails f_clr={f_clr} {...unitData}/>
      </Box>
      {
        Boolean(relatedUnits?.length) && <Box sx={{ pt: { xs: "20px", lg:'31.5px' }, pb: { xs: "20px", lg:'32px' } }} >
          <RelatedUnits relatedUnits={relatedUnits} />
        </Box>
      }
     {/* <Box sx={{ pt: { sx: "20px", lg:'31.5px' }, pb: { xs: "20px", lg:'32px' } }} >
          <RelatedUnits relatedUnits={relatedUnits} />
        </Box> */}
      <Box sx={{ pt: '40px' }}>
       <MainFooter />
      </Box>
    </div>
  );
}
